module.exports = "/images/avatar-s-4.jpg?6a665e7ccedce6cfb58f17aafae574ef";